import styled from 'styled-components'
import WhiteContainer from 'views/components/common/WhiteContainer'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-content: center;
`

export const TitleInventoryState = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #c6016b;
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 50px;
  margin-bottom: 18px;
`

export const LitleCardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 50px 0 10px 0;
`

export const InventoryStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 0;
`

export const LittleCard = styled(WhiteContainer)`
  gap: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #919eab;

  &:hover {
    transform: scale(1.05);
    transition: ease-in-out 0.3s;
  }
`

interface ITextLitleCard {
  color?: string
}

export const TextLitleCard = styled.span<ITextLitleCard>`
  font-size: 14px;
  font-weight: 700;
  color: ${(props: ITextLitleCard) => props.color || '#1F2124'};
`

export const CountTestAvailables = styled.span`
  font-weight: 700;
  font-size: 32px;
  color: #2d749c;
  text-align: 'center';
  margin: 4px 0px;
`

export const BigCard = styled(WhiteContainer)`
  display: flex;
  width: 100%;
  padding: 16px;
  width: 31.5%;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  min-height: 280px;
  max-height: 450px;
  height: 100%;
`

export const MyProcessContainer = styled(WhiteContainer)`
  padding: 16px;
  width: 25%;
  gap: 12px;
  display: flex;
  flex-direction: column;
  height: 80%;
  min-height: 240px;
`

export const BigContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 16px;
`
// items processes

export const ItemProcessContainer = styled.div`
  width: 100%;
  font-family: 'Public Sans', sans-serif;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const TextItalicProcess = styled.p`
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-style: italic;
  font-weight: 400;
  color: #707070;
`

export const TextEdit = styled.p`
  color: #2d749c;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Public Sans', sans-serif;
  cursor: pointer;
  margin-left: 10px;
`

interface IBadge {
  bgColor?: string
}

export const Badge = styled.div<IBadge>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Public Sans', sans-serif;
  font-size: 12px;
  background-color: ${(props: IBadge) => props.bgColor || '#60CC1E'};
  color: #ffffff;
  height: 16px;
  border-radius: 20px;
  padding: 6px 10px;
`

interface IRow {
  width?: string
  margin?: string
}

export const Row = styled.div`
  width: ${(props: IRow) => props.width || '100%'};
  margin: ${(props: IRow) => props.margin || '0'};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
export const ChartContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 2;
  height: 100%;
`

export const MyProcessBottomContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const MyProcessList = styled.div`
  position: relative;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-height: 200px;
  max-height: 380px;
  overflow-y: auto;
`

export const BannerContainer = styled(WhiteContainer)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
  border: 1px solid #f0c36d;
  background: linear-gradient(180deg, #fffaf0 0%, #fff4dc 100%);
`

export const BannerTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: #6b4f00;
`

export const BannerMessage = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #4e3d08;
`

export const BannerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`

export const InventoryListContainer = styled(WhiteContainer)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`

export const InventoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const InventoryItem = styled.div`
  display: grid;
  grid-template-columns: minmax(160px, 1fr) repeat(3, minmax(120px, auto));
  gap: 16px;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #e5e7eb;
`

export const InventoryItemLabel = styled.span`
  font-weight: 700;
  color: #1f2124;
`

export const InventoryItemValue = styled.span`
  font-size: 14px;
  color: #4b5563;
`

export const InventoryWarning = styled.span`
  grid-column: 1 / -1;
  padding: 8px 12px;
  border-left: 3px solid #c6016b;
  background-color: #fff4f8;
  color: #8b124f;
  font-size: 14px;
`
